var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRandomcolorz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 147,
    viewBox: "0 0 146 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_186)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.546631,
    y: 0.890808,
    width: 145.434,
    height: 145.434,
    rx: 32,
    fill: "#856088"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.0947266,
    y: 0.202606,
    width: 72.945,
    height: 146.81,
    fill: "#FAA0E6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 145,
    transform: "translate(0 1)",
    fill: "#E92045"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 35.5,
    r: 14.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 35.5,
    r: 14.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 73.5,
    r: 14.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 73.5,
    r: 14.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 111.5,
    r: 14.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 111.5,
    r: 14.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_186"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.546631,
    y: 0.890808,
    width: 145.434,
    height: 145.434,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomcolorz);
export default __webpack_public_path__ + "static/media/randomcolorz.9dd8c4fa8f99adea160ed15fd2dec420.svg";
export { ForwardRef as ReactComponent };